import React from 'react';
import { Typography } from '@mui/material';
import LegalPage from '../../components/LegalPage/LegalPage';

const Terms = () => (
    <LegalPage product="Relayr" title="Terms of Service">
        <p><strong>Effective Date:</strong> April 14, 2026</p>
        <p>
            Welcome to Relayr. These Terms of Service ("Terms") govern your access to and use of the Relayr mobile application ("App") and related services. By creating an account or using Relayr, you agree to be bound by these Terms. If you do not agree, please do not use the App.
        </p>

        <Typography variant="h6">1. Acceptance of Terms</Typography>
        <p>
            By accessing, downloading, or using Relayr, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy. If you are using Relayr on behalf of an organization, you represent that you have the authority to bind that organization to these Terms.
        </p>

        <Typography variant="h6">2. User Accounts</Typography>
        <ul>
            <li>You must provide accurate and complete information when creating your account.</li>
            <li>You are solely responsible for maintaining the confidentiality of your login credentials.</li>
            <li>You are responsible for all activity that occurs under your account.</li>
            <li>You must notify us immediately if you suspect unauthorized access to your account.</li>
        </ul>

        <Typography variant="h6">3. Acceptable Use</Typography>
        <p>You agree not to use Relayr to:</p>
        <ul>
            <li>Harass, abuse, threaten, or intimidate other users</li>
            <li>Post or distribute hate speech, discriminatory content, or violent material</li>
            <li>Engage in illegal activities or encourage others to do so</li>
            <li>Send spam, unsolicited messages, or malicious content</li>
            <li>Impersonate another person, user, or entity</li>
            <li>Post sexually explicit, obscene, or otherwise harmful content</li>
            <li>Attempt to gain unauthorized access to other accounts, networks, or systems</li>
            <li>Distribute malware, viruses, or any other harmful software</li>
        </ul>
        <p>
            Violation of these rules may result in content removal, account suspension, or permanent ban at our sole discretion.
        </p>

        <Typography variant="h6">4. Content &amp; Responsibility</Typography>
        <p>
            You retain ownership of the content you create and share on Relayr. By posting content, you grant Relayr a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content solely for the purpose of operating and providing the service.
        </p>
        <p>
            Relayr reserves the right to remove any content that violates these Terms or that we deem inappropriate, without prior notice. We do not guarantee the availability, accuracy, or integrity of any user-generated content.
        </p>

        <Typography variant="h6">5. Moderation &amp; Enforcement</Typography>
        <ul>
            <li>Relayr provides reporting tools that allow users to flag content or behavior that violates these Terms or community guidelines.</li>
            <li>We may review reported content and take action including, but not limited to, issuing warnings, removing content, temporarily restricting access, or permanently suspending accounts.</li>
            <li>Moderation decisions are made at our sole discretion and are final.</li>
        </ul>

        <Typography variant="h6">6. Termination</Typography>
        <p>
            We may suspend or terminate your account at any time, with or without cause, and with or without notice, if we believe you have violated these Terms or if your continued use poses a risk to the platform or other users.
        </p>
        <p>
            You may stop using Relayr at any time. To delete your account, contact us at <a href="mailto:support@relayr.app">support@relayr.app</a> or use the in-app account deletion feature if available.
        </p>

        <Typography variant="h6">7. Privacy</Typography>
        <p>
            Your use of Relayr is also governed by our Privacy Policy, which describes how we collect, use, and protect your information. By using the App, you consent to the practices described in the Privacy Policy.
        </p>

        <Typography variant="h6">8. Disclaimers</Typography>
        <p>
            Relayr is provided on an "as is" and "as available" basis without warranties of any kind, whether express or implied. We do not guarantee that the App will be uninterrupted, error-free, secure, or free of harmful components. We make no warranties regarding the accuracy, reliability, or completeness of any content available through the App.
        </p>

        <Typography variant="h6">9. Limitation of Liability</Typography>
        <p>
            To the fullest extent permitted by applicable law, Relayr and its affiliates, officers, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of data, loss of profits, or damages arising from user interactions, content posted by users, or your reliance on information obtained through the App.
        </p>

        <Typography variant="h6">10. Changes to Terms</Typography>
        <p>
            We reserve the right to modify these Terms at any time. When changes are made, we will update the "Effective Date" at the top of this page. We may notify users of significant changes through the App or via email. Your continued use of Relayr after any modifications constitutes acceptance of the updated Terms.
        </p>

        <Typography variant="h6">11. Governing Law</Typography>
        <p>
            These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles. Any disputes arising under these Terms shall be resolved in the appropriate courts of the jurisdiction in which Relayr operates.
        </p>

        <Typography variant="h6">12. Contact Us</Typography>
        <p>
            If you have any questions about these Terms of Service, please contact us at:
        </p>
        <p>Email: <a href="mailto:support@relayr.app">support@relayr.app</a></p>
    </LegalPage>
);

export default Terms;
